export default class ComboToppings extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            batchOfDropdownSelected: "",
            selectedItemForSubs: this.props.currentSelectedItems || []
           // isImageValid: false
        };
        this.toppingsWithSubObj = {};
        this.elementName = "";
        this.unqueModalName = "";
        this.subsValue = [];
        this.requiredSubModal = null;
        this.allCheckedSubs = {};
        this.bindMethods();
    }

    bindMethods() {
        [
            "modifierRow",
            "sendDataForAppending",
            "appendData",
            "sendDataForToppingsSubmenus",
            "getCalorieText",
            "keyPressAction",
            "enterPressAction",
            "handleImageError",
            "getAllCheckedCheckboxIds",
        ].forEach((method) => (this[method] = this[method].bind(this)));
    }

    handleImageError(e) {
        e.target.onerror = null;
        e.persist();
        e.target.remove();
    }

    componentDidMount() {
        $(document).on("change", ".combo-checkbox", function () {
            const isChecked = $(this).is(":checked");
            const cartItem = $(this).closest(".cart-items");
            if (isChecked) {
                cartItem.addClass("selected");
            } else {
                cartItem.removeClass("selected");
            }

        });
       // this.checkImage(this.props.image);

        const reactRefthis = this;
        const stackLength = this.props.noOfBatches.length;

        for (let i = 0; i < stackLength; i++) {
            $("#batch" + i + " #comboRadioBtn > input")
                .unbind()
                .click(function () {
                    const allNeigboringSVGs = $("#batch" + i + " i");
                    const minSelectCheckCount = $("#batch" + i).attr("data-minselects");
                    const maxSelectCheckCount = $("#batch" + i).attr("data-maxselects");
                    const isRequiredCheck = $("#batch" + i).attr("data-isrequired");

                    allNeigboringSVGs.attr("data-selected", "notSelected");
                   // allNeigboringSVGs.closest(".cart-items").removeClass("selected");

                    const checkedCountInput = $(
                        "#batch" + i + ' #comboRadioBtn > input[type=checkbox]:checked'
                    ).length || 0;
                    const moreOptionCount = $(
                        "#batch" + i + ' #moreOptions > i[data-selected="selected"]'
                    ).length || 0;

                    const totalCount = checkedCountInput + moreOptionCount;

                    if (minSelectCheckCount > 0) {
                        if (totalCount >= minSelectCheckCount) {
                            $("#comboSaveButton").attr("disabled", "disabled");
                        } else {
                            $("#comboSaveButton").attr("disabled", false);
                        }
                    }

                    if (
                        (minSelectCheckCount == null || minSelectCheckCount == "null") &&
                        (maxSelectCheckCount == null || maxSelectCheckCount == "null") &&
                        (isRequiredCheck == "true" || isRequiredCheck == true)
                    ) {
                        allNeigboringSVGs.closest(".cart-items").removeClass("selected");
                        $("#batch" + i + " #comboRadioBtn > input")
                            .not(this)
                            .prop("checked", false);
                        $("#batch" + i + " #comboRadioBtn > input")
                            .not(this)
                            .closest(".cart-items")
                            .removeClass("selected");
                    } else if (
                        (minSelectCheckCount == null || minSelectCheckCount == "null") &&
                        (maxSelectCheckCount == null || maxSelectCheckCount == "null") &&
                        (isRequiredCheck == "false" || isRequiredCheck == false)
                    ) {
                        $("#batch" + i + ' #comboRadioBtn > input[type=checkbox]').attr(
                            "disabled",
                            false
                        );
                    } else if (maxSelectCheckCount == "0") {
                        $("#batch" + i + ' #comboRadioBtn > input[type=checkbox]')
                            .prop("checked", false)
                            .attr("disabled", "disabled");
                        $("#batch" + i + ' #comboRadioBtn > input[type=checkbox]')
                            .closest(".cart-items")
                            .removeClass("selected");
                    } else if (
                        maxSelectCheckCount == "1" ||
                        typeof maxSelectCheckCount === "undefined"
                    ) {
                        $("#batch" + i + " #comboRadioBtn > input")
                            .not(this)
                            .prop("checked", false);
                        $("#batch" + i + " #comboRadioBtn > input")
                            .not(this)
                            .closest(".cart-items")
                            .removeClass("selected");
                    } else if (maxSelectCheckCount > 1) {
                        if (checkedCountInput >= maxSelectCheckCount) {
                            $("#batch" + i + ' #comboRadioBtn > input[type=checkbox]:not(:checked)').attr(
                                "disabled",
                                "disabled"
                            );
                        } else {
                            $("#batch" + i + ' #comboRadioBtn > input[type=checkbox]').attr(
                                "disabled",
                                false
                            );
                        }
                    }

                    const batchIdOfClickedCB = "batch" + i;
                    reactRefthis.props.sendCheckedState(batchIdOfClickedCB);
                });

            $("#batch" + i + " #moreOptions > i")
                .closest("div.cart-items")
                .unbind()
                .click(function () {
                    const chevron = $(this).find("i.moreoption-icon")[0];
                    const batchOfDropdownSelected = "batch" + i;

                    if ($(chevron).attr("data-selected") === "notSelected") {
                        reactRefthis.props.sendCheckedState(batchOfDropdownSelected);
                    }
                    $(chevron).attr("data-selected", "selected");
                    $(chevron).closest(".cart-items").addClass("selected");

                    const allNeigboringSVGs = $(
                        "#batch" + i + " #moreOptions > i"
                    ).not($(chevron));
                    allNeigboringSVGs.each(function () {
                        $(this).attr("data-selected", "notSelected");
                        $(this).closest(".cart-items").removeClass("selected"); 
                    });

                    reactRefthis.elementName = $(chevron).attr("data-name");
                    reactRefthis.unqueModalName = $(chevron).attr("data-modalname");

                    $("#mainMenuContainer #batch" + i + " input").prop("checked", false);
                    $("#mainMenuContainer #batch" + i + " input")
                        .closest(".cart-items")
                        .removeClass("selected");

                    setTimeout(() => {
                        $(
                            '#subMenusContainer  input[data-parent="' +
                            reactRefthis.elementName +
                            '"]'
                        ).attr("id", "batch" + i);
                    }, 1000);

                    sessionStorage.setItem(
                        "selected-submenuid",
                        $(chevron).attr("data-toppingid")
                    );
                });

            $("#moreOptions > i")
                .closest("div.cart-items")
                .click(function () {
                    $("#modalContent").hide();
                    $("#subMenusContainer").css("margin-top", "-45px").show();
                    $("#subMenusContainer .menu-category").css("padding-left", "0px");
                    $(".modal-body").scrollTop(0);
                });

            $("#subMenusContainer  input").click(function () {
                $("#subMenusContainer  input").not(this).prop("checked", false);
                $("#subMenusContainer  input")
                    .not(this)
                    .closest(".cart-items")
                    .removeClass("selected");
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.selectedItemForSubs !== this.state.selectedItemForSubs) {
            this.forceUpdate();
        }
       /* if (prevProps.image !== this.props.image) {
            
            this.checkImage(this.props.image);
            
        }*/
    }
   /* checkImage(url){
        if (!url) {
            this.setState({ isImageValid: false });
            return;
        }

        const img = new Image();

        img.onload = () => {
            console.log("Image loaded successfully:", url); 
            this.setState({ isImageValid: true });
        };

        img.onerror = () => {
            console.error("Image failed to load:", url);    
            this.setState({ isImageValid: false });
        };

        img.src = url;
    }
*/
    getAllCheckedCheckboxIds(batchSelector) {
        const checkedCheckboxes = $(
            `${batchSelector} #comboRadioBtn > input[type=checkbox]:checked`
        );
        const checkedIds = checkedCheckboxes
            .map((_, checkbox) => $(checkbox).attr("data-toppingid"))
            .get();
        return checkedIds;
    }

    modifierRow(e) {
        const chkBox = $(e.currentTarget).find("input[type=checkbox]");
        if (chkBox.length > 0 && !$(e.target).is(":checkbox")) {
            $(chkBox[0]).trigger("click");
            this.sendDataForAppending($(chkBox[0]));
        } else {
            const chevron = $(e.currentTarget).find("i.moreoption-icon");
            if (chevron.length > 0) {
                this.sendDataForToppingsSubmenus($(chevron[0]));
            }
        }
    }

    appendData(e) {
        e.stopPropagation();
        this.sendDataForAppending(e.target);
    }

    sendDataForToppingsSubmenus(elem) {
        this.requiredSubModal = $(
            "#subMenusContainer .h1.category-title:contains('- required')"
        );

        this.toppingsWithSubObj = {
            parentTitle: this.props.parentHeaderTitle,
            childTitle: this.props.toppingsNames,
            upDatedPrice: this.props.price,
            updatedId: this.props.toppingId,
        };

        this.props.sendUpdatedToppingsHeaderTitleAndPrice(this.toppingsWithSubObj);
        this.props.sendDataForToppingsSubmenus(this.props.toppingsNames);

        const selectedSub = this.props.multipleCheckedSubs.filter(
            (checkedSub) => $(elem).data("name") === checkedSub.parentName
        );

        setTimeout(() => {
            if (
                selectedSub.length > 0 &&
                $("#comboSaveButton").is(":disabled")
            ) {
                $(
                    `#subMenusContainer input[value="${selectedSub[0].label}"]:visible`
                ).prop("checked", true);
                $(
                    `#subMenusContainer input[value="${selectedSub[0].label}"]:visible`
                )
                    .closest(".cart-items")
                    .addClass("selected");
            }
        }, 500);

        this.isRequired = !!this.requiredSubModal[0];
        $("#comboSaveButton").prop("disabled", this.isRequired);

        if (this.props.isEditMode) {
            const subCheckboxKey = this.props.toppingId;

            setTimeout(() => {
                const currentButtonSnapshotForSubs = JSON.parse(
                    sessionStorage.getItem(`default-mod-${subCheckboxKey}`)
                );
                const selectedItemForSubs = $(
                    `input[data-toppingid="${currentButtonSnapshotForSubs.selectedItemId}"]`
                );
                $(selectedItemForSubs).prop("checked", true);
                $(selectedItemForSubs).closest(".cart-items")
                    .addClass("selected");
            }, 500);

            this.props.sendUpdatedEditMode(false);
        }
    }

    getCalorieText() {
        const { toppingCalories, calorieAdds, calorieSubtracts } = this.props;
        return toppingCalories > 0
            ? `${calorieAdds} ${toppingCalories}`
            : toppingCalories < 0
                ? `${calorieSubtracts} ${-1 * toppingCalories}`
                : "0";
    }

    sendDataForAppending(elem) {
        const isChecked = $(elem).is(":checked");
        const { price, toppingId, isRequired } = this.props;

        if (isChecked) {
            if ($("#comboSaveButton").attr("data-modifierlevel") === "second") {
                this.allCheckedSubs = {
                    isChecked: true,
                    label: $(elem).attr("value"),
                    parentName: $(elem).attr("data-parent"),
                    subPrice: $(elem).attr("data-toppingprice"),
                    modalNmame: $(elem).attr("data-modalname"),
                    batchNo: $(elem).attr("id"),
                    componentId: $(elem).attr("data-toppingid"),
                };
                this.props.sendCheckedState(this.allCheckedSubs);
            } else {
                $("#comboSaveButton").prop("disabled", false);
                this.props.sendAppendedId(toppingId);
            }
            this.props.sendUpdatedPrice(parseFloat(price));
        } else {
            if ($("#comboSaveButton").attr("data-modifierlevel") === "second") {
                this.props.sendCheckedState($(elem).attr("id"));
                $("#comboSaveButton").prop("disabled", this.isRequired);
            } else {
                $("#comboSaveButton").prop("disabled", isRequired);
            }
        }
    }

    keyPressAction(event) {
        if (event.keyCode === 13) {
            $(document.activeElement).find("input").trigger("click");
            $("#comboSaveButton").prop("disabled", false);
        }
    }

    enterPressAction(event) {
        if (event.keyCode === 13) {
            $(document.activeElement).find("i").trigger("click");
            $("#comboSaveButton").prop("disabled", false);
        }
    }

    render() {
        const {
            image,
            modifierSlugName,
            toppingsNames,
            price,
            toppingCalories,
            calorieAbbr,
            caloriesText,
            thereIsMore,
            parentHeaderTitle,
            toppingId,
        } = this.props;
        const { isImageValid } = this.state;

        return (
            <div onClick={this.modifierRow} className={`cart-items cart-items2`}>
                <div className="cart-description">
                    <div className="cart-detail">
                        <div className="js-cart-item-product-img" tabIndex="0">
                           {/* <div className="image-placeholder">
                                {isImageValid && (
                                    <img
                                        src={image}
                                        alt={modifierSlugName || "Modifier Image"}
                                        className="mx-auto d-block food-img img-fluid"
                                        loading="lazy"
                                        decoding="async"
                                    />
                                )}
                            </div>*/}
                        </div>
                        <div className="gutter-padding" tabIndex="0">
                            <div className="details">
                                <h5 className="toppings-title">{toppingsNames}</h5>
                                {((price !== "$0.00" && price != "0.00") || toppingCalories) && (
                                    <div className="priceDetails">
                                        {(price !== "$0.00" && price != "0.00") && (
                                            <span className="addcombo-price">
                                                +${price.toFixed(2)}
                                            </span>
                                        )}
                                        {(price !== "$0.00" && price != "0.00") &&
                                            toppingCalories && <span className="text-gray"> | </span>}
                                        {toppingCalories && (
                                            <span className="item-cal">
                                                {this.getCalorieText()}{" "}
                                                <abbr aria-label={caloriesText}>{calorieAbbr}</abbr>
                                            </span>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {thereIsMore ? (
                        <div
                            className="col-2"
                            tabIndex="0"
                            onKeyDown={this.enterPressAction}
                        >
                            <div
                                id="moreOptions"
                                data-modalname={parentHeaderTitle}
                                data-toppingid={toppingId}
                                data-toppingprice={parseFloat(price)}
                                data-name={toppingsNames}
                                data-selected="notSelected"
                                className="text-right d-none"
                                aria-label={`More options for ${toppingsNames}`}
                            >
                                <i
                                    className="fa fa-angle-right moreoption-icon"
                                    aria-hidden="true"
                                    data-modalname={parentHeaderTitle}
                                    data-toppingid={toppingId}
                                    data-toppingprice={parseFloat(price)}
                                    data-name={toppingsNames}
                                    data-selected="notSelected"
                                ></i>
                            </div>
                        </div>
                    ) : (
                        <div className="checkmark-section">
                            <span className="checkmark">
                                <i className="bi bi-check"></i>
                            </span>

                            <div
                                id="comboRadioBtn"
                                onKeyDown={this.keyPressAction}
                                className="toppings-radiobox float-right d-none"
                            >
                                <input
                                    key={this.props.toppingId}
                                    data-toppingid={this.props.toppingId}
                                    data-isdefault={this.props.isDefaultItem}
                                    data-toppingprice={parseFloat(this.props.price)}
                                    data-modalname={this.props.parentHeaderTitle}
                                    data-mainId={this.props.parentHeaderId}
                                    data-parent={this.props.parentComponentName}
                                    className="combo-checkbox"
                                    type="checkbox"
                                    name="food"
                                    value={this.props.toppingsNames}
                                    aria-label={this.props.toppingsNames}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
